<script lang="ts">
  export let value = false;
  export let label: string | { on: string; off: string } | undefined = undefined;
  export let labelPosition: "left" | "right" = "right";
  export let loading = false;
  export let highlight = false;
  export let containerClass = "";
  export let canToggle = true;
  export let toggleGuard = () => {};
  import { cn } from "$lib/utils";

  let internalValue: boolean;
  $: internalValue = value;

  $: toggleClasses = cn(
    "toggle pointer-events-none inline-block transform rounded-full ring-0 transition duration-300 ease-in-out",
    "h-[14px] w-[14px] mt-[2px] ml-[2px]",
    internalValue ? "translate-x-[13.5px]" : "translate-x-0",
    highlight && internalValue ? "bg-theme-green dark:bg-theme-green" : "bg-white/80 dark:bg-theme-gray-600",
  );

  $: switchClasses = cn(
    "switch relative inline-flex flex-shrink-0 cursor-pointer rounded-full outline-white transition-colors duration-300 ease-in-out",
    "h-[18px] w-[32px]",
    "bg-white/20 dark:bg-theme-background-primary",
    loading && "animate-pulse",
  );

  function handleToggle() {
    if (canToggle) {
      internalValue = !internalValue;
      value = internalValue;
    } else {
      value = false;
      toggleGuard();
    }
  }

  function getLabelText() {
    if (!label) return "";
    if (typeof label === "string") return label;
    return internalValue ? label.on : label.off;
  }
</script>

<div
  class={cn(
    "transition-default flex items-center text-xs",
    containerClass,
    "dark:text-theme-text-secondary",
    highlight && internalValue && "text-theme-green dark:text-theme-green",
  )}
>
  {#if label && labelPosition === "left"}
    <span class="mr-2">{getLabelText()}</span>
  {/if}

  <button
    type="button"
    class={switchClasses}
    role="switch"
    aria-checked={internalValue}
    onclick={handleToggle}
    aria-label={getLabelText() || "Toggle switch"}
  >
    <span class={toggleClasses}></span>
  </button>

  {#if label && labelPosition === "right"}
    <span class="ml-1.5">{getLabelText()}</span>
  {/if}
</div>
